export const SET_ACTIVE_LANG = 'SET_ACTIVE_LANG';

export function setActiveLangAction(iso) {
    return {
      type: SET_ACTIVE_LANG,
      iso
    }
  }